import React from 'react';
import PropTypes from 'prop-types';
import Card from '@mui/material/Card';
import Divider from '@mui/material/Divider';
import Icon from '@mui/material/Icon';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDBadge from 'components/MDBadge';
import MDButton from 'components/MDButton';

function MachineCard({
  color,
  icon,
  deviceName,
  branchId,
  address,
  sido,
  useTime,
  petCount,
  status,
  onRequestPickup,
}) {
  return (
    <Card>
      <MDBox display='flex' justifyContent='space-between' pt={1} px={2}>
        <MDBox
          variant='gradient'
          bgColor={color}
          color={color === 'light' ? 'dark' : 'white'}
          coloredShadow={color}
          borderRadius='xl'
          display='flex'
          justifyContent='center'
          alignItems='center'
          width='4rem'
          height='4rem'
          mt={-3}
        >
          <Icon fontSize='medium' color='inherit'>
            ballot
          </Icon>
        </MDBox>
        <MDBox textAlign='left'>
          <MDTypography variant='h4'>{deviceName}</MDTypography>
        </MDBox>
        <MDBox textAlign='right' lineHeight={1.25}>
          <MDTypography variant='h5' fontWeight='medium' color='text'>
            펫트수량
          </MDTypography>
          <MDTypography variant='h4'>{petCount}</MDTypography>
        </MDBox>
      </MDBox>
      <Divider />
      <MDBox px={2}>
        <MDTypography variant='h7'>주소: {address}</MDTypography>
      </MDBox>
      <MDBox px={2}>
        <MDTypography variant='h7'>사용시간: {useTime}</MDTypography>
      </MDBox>
      <Divider />
      <MDBox pb={2} px={2} display='flex' justifyContent='space-between'>
        <MDBadge
          badgeContent={
            status === 'on' ? 'online' : status === 'off' ? 'offline' : 'full'
          }
          color={
            status === 'on' ? 'success' : status === 'off' ? 'dark' : 'warning'
          }
          variant='gradient'
          size='lg'
        />
        <MDButton color='warning' onClick={onRequestPickup}>
          회수요청
        </MDButton>
      </MDBox>
    </Card>
  );
}

MachineCard.propTypes = {
  color: PropTypes.oneOf([
    'primary',
    'secondary',
    'info',
    'success',
    'warning',
    'error',
    'light',
    'dark',
  ]).isRequired,
  icon: PropTypes.node.isRequired,
  deviceName: PropTypes.string.isRequired,
  branchId: PropTypes.number.isRequired,
  address: PropTypes.string.isRequired,
  sido: PropTypes.string.isRequired,
  useTime: PropTypes.string.isRequired,
  petCount: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  onRequestPickup: PropTypes.func.isRequired,
};

export default MachineCard;
